import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import UserContext from '../../contexts/UserContext';
import authenticate from '../../utils/Authenticate';
import displayError from '../../utils/ErrorHandler';

const SupplyApproval = () => {
    const [requests, setRequests] = useState([]);
    const [checkedItems, setCheckedItems] = useState({});
    const [isBannerVisible, setIsBannerVisible] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [message,setMessage] = useState('');
    const { user, setUser } = useContext(UserContext);
    const navigate = useNavigate();

    useEffect(() => {
        async function startup() {
            if (!user) {
                await authenticate(setUser, navigate);
            }
            if (user) {
                fetchRequests();
            }
        }
        startup();
    }, [user, successMessage]);

    const fetchRequests = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URI}/api/supplier/getRequests`, { withCredentials: true });
            // const requestsWithIndex = response.data.data
            //     .map((request, index) => ({ ...request, originalIndex: index }))
            //     .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
                const requestsWithIndex = Array.isArray(response?.data?.data)
                ? response.data.data
                .map((request, index) => ({ ...request, originalIndex: index }))
                .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)):[];
            setRequests(requestsWithIndex);
            console.log(requestsWithIndex);
        } catch (err) {
            const errorMessage = displayError(err,navigate,setUser);
            console.log(errorMessage);
            if(errorMessage){
                setMessage(errorMessage)
            }
        }
    };

    const handleCheckboxChange = (requestId, item, isChecked) => {
        setCheckedItems(prevState => {
            const newCheckedItems = { ...prevState };
            const key = `${requestId}-${item._id}`;
            if (isChecked) {
                newCheckedItems[key] = {
                    requestId: requestId,
                    itemId: item.item._id,
                    name: item.item.name,
                    quantity: item.quantity,
                };
            } else {
                delete newCheckedItems[key];
            }
            return newCheckedItems;
        });
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const filteredRequests = requests.filter((request) =>
       `REQ00${request.requestNumber}`.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const checkedItemsCount = Object.keys(checkedItems).length;

    useEffect(() => {
        if (checkedItemsCount > 0) {
            setIsBannerVisible(true);
        } else {
            const timeoutId = setTimeout(() => {
                setIsBannerVisible(false);
            }, 300);
            return () => clearTimeout(timeoutId);
        }
    }, [checkedItemsCount, successMessage]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = String(date.getFullYear()).slice(-2);
        return `${day}/${month}/${year}`;
    };

    const addAndUpdate = () => {
        const updateStatus = Object.values(checkedItems).map(item => ({
            requestId: item.requestId,
            itemId: item.itemId
        }));

        const updateRequestStatus = axios.put(
            `${process.env.REACT_APP_API_URI}/api/supplier/approveItem`,
            { updateStatus },
            { withCredentials: true }
        );

        Promise.all([updateRequestStatus])
            .then(([updateRequestResponse]) => {
                setSuccessMessage('Items approved!');
                setErrorMessage('');
                setCheckedItems(0);
                setIsBannerVisible(false);
                setTimeout(() => {
                    navigate('/central/supplyapproval');
                }, 1000);
            })
            .catch((error) => {
                setErrorMessage('An error occurred while processing your request. Please try again.');
                setSuccessMessage('');
                console.error(error);
            });
        fetchRequests();
    };

    const submitSupplierForRequest = (e, request) => {
        e.preventDefault();
        const approvedItems = request.items.filter(item => item.status === 'supplyapproved');
        const finalObject = {
            request,
            items: approvedItems,
            dispatch: {
                comments: 'Test Comments',
                vehicleNo: 'TN047865',
                contact: '97841415155'
            }
        };
        axios.post(`${process.env.REACT_APP_API_URI}/api/supplier/updateDispatch`, finalObject, { withCredentials: true })
            .then((response) => {
                console.log(response.data);
            })
            .catch((error) => {
                console.error(error);
            });
        fetchRequests();
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'supplyrequested':
                return 'bg-orange-100 text-orange-700';
            case 'pending':
                return 'bg-red-100 text-red-700';
            case 'supplyapproved':
                return 'bg-green-100 text-green-700';
            case 'dispatched':
                return 'bg-blue-100 text-blue-700';
            case 'received':
                return 'bg-green-100 text-green-700';
            default:
                return 'bg-blue-100 text-blue-700';
        }
    };

    const renderRequestItems = (request) => {
        const itemsToRender = request.items.map((item, idx) => (
            <div key={item._id} className={`relative flex items-center pb-4 mb-2 ${idx < request.items.length - 1 ? 'border-b pb-2' : ''}`}>
                <label className="custom-checkbox flex-shrink-0">
                    <input
                        type="checkbox"
                        disabled={item.status !== 'supplyrequested'}
                        checked={checkedItems[`${request._id}-${item._id}`] !== undefined}
                        onChange={(e) => handleCheckboxChange(request._id, item, e.target.checked)}
                    />
                    <span className="checkmark"></span>
                </label>
                <div className="flex-grow ml-2">
                    <h3 className="text-[15px] text-fmb font-semibold">{item.item.name}</h3>
                    <p className="text-sm text-gray-600">{item.item.category}</p>
                    
                </div>
                <div className="ml-4 -mt-4 text-center">
                    <p className="text-lg text-gray-600 font-semibold">{item.quantity} {item.item.unit}</p>
                </div>
                <div className={`absolute bottom-3 -end-4 text-xs px-2 py-1 mt-1 rounded-l-lg font-semibold ${getStatusColor(item.status)}`}>
                    {item.status}
                </div>
            </div>
        ));
        
        return (
            <div>
                <div>
            <span className="text-lime-700 text-sm font-semibold">Zone : {request.items[0].zone.desc}</span>
        </div>
                {itemsToRender}
            </div>
        );
    };

    return (
        <div className="p-4 pb-20">
            {message?
        <div class="bg-red-100 border border-red-300 text-red-500 px-4 py-3 mx-0 rounded relative" role="alert">
          <span class="block sm:inline">{message}</span>
          <span class="absolute top-0 bottom-0 right-0 px-4 py-3">
          </span>
        </div>
        :null}
            <input
                type="text"
                placeholder="Search requests..."
                value={searchQuery}
                onChange={handleSearchChange}
                className="mb-4 p-2 border border-gray-300 rounded w-full"
            />
            {filteredRequests.length > 0 ? (
                filteredRequests.map((request) => {
                    const approvedItems = request.items.filter(item => item.status === 'supplyapproved');
                    return (
                        <div key={request._id} className="bg-white p-4 mb-3 border rounded shadow-md relative">
                            <div className="flex justify-between items-center mb-2">
                                <h2 className="text-[16px] font-semibold text-gray-700">
                                    REQ00{request.requestNumber}
                                </h2>
                                <h4 className="text-sm text-gray-400">{formatDate(request.date)}</h4>
                            </div>
                            {renderRequestItems(request)}
                            {approvedItems.length > 0 && (
                                <div className="mt-4 flex justify-end">
                                    <button 
                                        onClick={(e) => navigate("/supplier/dispatch", { state: { request,approvedItems } })}
                                        className="bg-green-600 text-sm text-white py-2 px-3 rounded hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-opacity-50"
                                    >
                                        Dispatch
                                    </button>
                                </div>
                            )}
                        </div>
                    );
                })
            ) : (
                <p className="text-gray-600">No requests found.</p>
            )}

            {isBannerVisible && (
                <div className={`fixed bottom-0 pb-20 left-0 right-0 p-4 bg-yellow-100 shadow-lg ${checkedItemsCount > 0 ? 'animate-slideIn' : 'animate-slideOut'}`}>
                    {successMessage && <div style={{ color: 'green' }}>{successMessage}</div>}
                    {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
                    <div className='flex justify-between items-center'>
                        <span className="text-[14px] font-semibold">{checkedItemsCount} items selected</span>
                        <button className="text-[15px] bg-fmb text-white px-4 py-2 rounded font-medium" onClick={addAndUpdate}>Approve Items</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SupplyApproval;
